import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'nx-ng-basket-discount-voucher',
  templateUrl: './basket-discount-voucher.component.html',
  styleUrls: ['./basket-discount-voucher.component.scss'],
})
export class BasketDiscountVoucherComponent {
  @Input()
  error = '';

  @Input()
  loading = false;

  @Input()
  expanded = false;

  @Input()
  voucherCode = '';

  @Input()
  applied = false;

  @Output()
  isExpandedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  applyDiscount: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  removeDiscount: EventEmitter<string> = new EventEmitter<string>();

  get voucherCodeValid() {
    return this.voucherCode && this.voucherCode.length >= 4;
  }

  open(): void {
    this.expanded = true;
    this.isExpandedChange.emit(this.expanded);
  }

  close(): void {
    this.expanded = false;
    this.isExpandedChange.emit(this.expanded);
  }

  handleApplyDiscount(voucherCode: string) {
    if (this.voucherCodeValid && !this.applied) {
      this.applyDiscount.emit(voucherCode);
    }
  }

  handleRemoveDiscount(voucherCode: string) {
    this.removeDiscount.emit(voucherCode);
  }
}
